import React from "react";
import PropTypes from "prop-types";

export default class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };

    this.wrapperRef = React.createRef();
    this.tooltipRef = React.createRef();
    this.contentRef = React.createRef();
    this.arrowRef = React.createRef();
    this.gapRef = React.createRef();
    this.handleTouch = this.handleTouch.bind(this);
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if ($(".tooltip-box")[0]) {
      $(".tooltip-box").fadeTo(150, 1);
    }
  }

  show() {
    this.setState({ visible: true });
  }

  hide() {
    this.setState({ visible: false });
  }

  handleTouch() {
    this.show();
    this.handleOutsideTouch();
  }

  handleOutsideTouch() {
    const handler = e => {
      let currentNode = e.target;
      const componentNode = this.wrapperRef.current;
      while (currentNode.parentNode) {
        if (currentNode === componentNode) {
          return;
        }
        currentNode = currentNode.parentNode;
      }
      if (currentNode !== document) {
        return;
      }
      this.hide();
      document.removeEventListener("touchstart", handler);
    };
    document.addEventListener("touchstart", handler);
  }

  renderTooltip() {
    if (this.state.visible || this.props.visible) {
      return (
        <div className={"tooltip-box " + this.props.location} ref={this.tooltipRef}>
          <span className="content" ref={this.contentRef}>
            {this.props.content}
          </span>
          <div className="arrow" ref={this.arrowRef} />
          <div className="gap" ref={this.gapRef} />
        </div>
      );
    }
  }

  render() {
    if (this.props.available) {
      return (
        <span className="tooltip-container">
          <div
            ref={this.wrapperRef}
            className={"tooltip-wrapper " + this.props.className}
            onMouseEnter={this.show}
            onMouseLeave={this.hide}
            onTouchStart={this.handleTouch}
          >
            {this.props.children}
          </div>
          {this.renderTooltip()}
        </span>
      );
    } else {
      return <div className={this.props.className}>{this.props.children}</div>;
    }
  }
}

Tooltip.defaultProps = {
  available: true,
  location: "center"
};

Tooltip.propTypes = {
  location: PropTypes.oneOf(["left", "center", "right"]),
  children: PropTypes.any.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};
